import { all } from "redux-saga/effects";
import { watchAddNewClass, watchDeleteClass, watchFetchAllClasses, watchMount, watchUnmount } from "./watchers";

export function* classesSagas() {
  yield all([watchAddNewClass(), watchDeleteClass(), watchFetchAllClasses(), watchMount(), watchUnmount()]);
}
